import {Col, Row} from 'react-bootstrap-v5'
import {Modal} from 'rsuite'

type Props = {
  data: {
    id: String
    grievanceCode: String
    fullName: String
    email: String
    department: {
      id: String
      name: String
      nameNp: String
    }
    mobileNumber: String
    message: String
    accountNumber: String
    preferredBranch: [
      {
        id: String
        name: String
      }
    ]
    serviceCategory: [
      {
        id: String
        name: String
      }
    ]
    serviceType: [
      {
        id: String
        name: String
      }
    ]
    serviceSubType: [
      {
        id: String
        name: String
      }
    ]
    status: [
      {
        id: String
        name: String
      }
    ],
    subject: String,
    created_at:String
  }
  handleClose: () => void
}

const ViewGrievanceDetails = ({data, handleClose}: Props) => {
  return (
    <div className='modal-container'>
      <Modal
        open={true}
        onClose={handleClose}
        // className='w-75'
        // size='md'
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>Grievance Details </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Row className='mb-2'>
              <Col xs={4}>
                <strong>Grievance code</strong>
              </Col>
              <Col xs={8} className='text-break'>
                {data?.grievanceCode}
              </Col>
            </Row>
            <Row className='mb-2'>
              <Col xs={4}>
                <strong>Full Name</strong>
              </Col>
              <Col xs={8} className='text-break'>
                {data?.fullName}
              </Col>
            </Row>
            <Row className='mb-2'>
              <Col xs={4}>
                <strong>Email</strong>
              </Col>
              <Col xs={8} className='text-break'>
                {data?.email}
              </Col>
            </Row>
            <Row className='mb-2'>
              <Col xs={4}>
                <strong>Contact number</strong>
              </Col>
              <Col xs={8} className='text-break'>
                {data?.mobileNumber}
              </Col>
            </Row>
            <Row className='mb-2'>
              <Col xs={4}>
                <strong>Submitted date</strong>
              </Col>
              <Col xs={8} className='text-break'>
                {data?.created_at}
              </Col>
            </Row>
            <Row className='mb-2'>
              <Col xs={4}>
                <strong>Subject</strong>
              </Col>
              <Col xs={8} className='text-break'>
                {data?.subject}
              </Col>
            </Row>
            {/* <Row className='mb-2'>
              <Col xs={4}>
                <strong>Account Number</strong>
              </Col>
              <Col xs={8}>{data?.accountNumber}</Col>
            </Row> */}
            <Row className='mb-2'>
              <Col xs={4}>
                <strong>Message</strong>
              </Col>
              <Col xs={8} className='text-break'>
                {data?.message}
              </Col>
            </Row>
            {/* <Row className='mt-5'>
              <Col md={24}>Assigned To: {data?.department?.name || 'N/A'}</Col>
            </Row> */}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default ViewGrievanceDetails
